import React, { useState } from 'react';
import classes from "./UserLogs.module.css";
import Layout from '../components/Layout';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { userLogsApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from "moment-timezone";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { removeToken } from '../store/slices/tokenSlice';
import Spinner from '../components/Spinner';
import { useTranslation } from 'react-i18next';

const UserLogs = () => {
    const [msisdn, setMsisdn] = useState("");
    const { tokenData } = useSelector(state => state?.tokenSlice);

    const [loading, setLoading] = useState(false);
    const [subscriptionLogs, setSubscriptionLogs] = useState(null);
    const [billingLogs, setBillingLogs] = useState(null);
    const [unsubscriptionLogs, setUnsubcriptionLogs] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const fetchUserLogs = async (e) => {
        try {
            e.preventDefault();
            if (!msisdn) {
                return;
            }
            setLoading(true);
            const response = await userLogsApi(msisdn, tokenData);
            console.log(response?.data?.result, 'result...');
            setSubscriptionLogs(response?.data?.result?.subscription_logs ?? null);
            setUnsubcriptionLogs(response?.data?.result?.unsubscription_logs ?? null);
            setBillingLogs(response?.data?.result?.billing_logs ?? null);
            setLoading(false);
            setMsisdn("");


        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);


            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error(t('common.tokenExpired'));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || t('common.somethingWentWrong'));
            }
        }
    }
    return (
        <Layout active={1}>

            <div className={classes.message_container}>
                <p className={classes.message_title}>{t('userLogs.title')}</p>
            </div>

            <form className={classes.search_container} onSubmit={fetchUserLogs}>
                <InputNumber value={msisdn} onValueChange={(e) => setMsisdn(e.value)} useGrouping={false} placeholder={t('form.enterUserNumber')}
                />
                <Button label={t('common.search')} type='submit' />
            </form>

            {loading && <Spinner />}

            {
                subscriptionLogs && (
                    <div className={classes.table_container}>
                        <DataTable
                            value={[...subscriptionLogs]}
                            emptyMessage={t('userLogs.userNotSubscribed')}
                            showGridlines
                            responsive
                            scrollable
                            scrollDirection="both"
                            header={
                                <p className={classes.table_header}>
                                    {t('userLogs.subscriptionDetails')}
                                </p>
                            }
                            scrollHeight="500px"
                        >
                            <Column field="sub_date_time" header={t('userLogs.subscriptionDateTime')}
                                body={(rowData) =>
                                    moment(rowData?.sub_date_time).format("DD-MM-YYYY")
                                }
                            />
                            <Column
                                field="msisdn"
                                header={t('common.msisdn')}
                            />
                            <Column
                                field="name"
                                header={t('common.name')}
                            />
                            <Column
                                field="image"
                                header={t('common.image')}
                                body={(rowData) =>
                                    rowData?.image != null ? <img src={rowData?.image} alt="avatar" style={{ width: "64px", height: "64px", objectFit: "contain" }} />
                                        : t('common.noImage')
                                }

                            />
                            <Column
                                field="total_points"
                                header={t('userLogs.totalPoints')}

                            />
                            <Column
                                field="next_billing_date"
                                header={t('userLogs.nextBillingDate')}
                                body={(rowData) =>
                                    moment(rowData?.next_billing_date).format("DD-MM-YYYY")
                                }
                            />

                                <Column
                                field="pack_type"
                                header={t('userLogs.packType')}
                            />
                            
                            {/* <Column
                                field="mAct"
                                header="Subscription Type"
                            /> */}

                            <Column
                                field="mAct"
                                header={t('userLogs.subscriptionChannel')}
                            />

                        </DataTable>
                    </div>
                )
            }

            {
                billingLogs && (
                    <div className={classes.table_container}>
                        <DataTable
                            value={[...billingLogs]}
                            emptyMessage={t('userLogs.noBillingDetails')}
                            showGridlines
                            responsive
                            scrollable
                            scrollDirection="both"
                            scrollHeight="500px"
                            header={
                                <p className={classes.table_header}>
                                    {t('userLogs.billingDetails')}
                                </p>
                            }
                        >
                            <Column field="msisdn" header={t('common.msisdn')}
                            />
                            <Column
                                field="billing_date"
                                header={t('userLogs.billingDateTime')}
                                body={(rowData) =>
                                    moment(rowData?.billing_date).toLocaleString()
                                }
                            />
                            <Column
                                field="next_billing_date"
                                header={t('userLogs.nextBillingDate')}
                                body={(rowData) =>
                                    moment(rowData?.next_billing_date).format("DD-MM-YYYY")
                                }
                            />
                            <Column
                                field="pack_type"
                                header={t('userLogs.packType')}
                            />
                            <Column
                                field="amount"
                                header={t('common.amount')}
                            />
                            <Column
                                field="currency"
                                header={t('common.currency')}
                            />
                            <Column
                                field="mAct"
                                header={t('userLogs.subscriptionType')}
                            />

                        </DataTable>
                    </div>
                )
            }

            {
                unsubscriptionLogs && (
                    <div className={classes.table_container}>
                        <DataTable
                            value={[...unsubscriptionLogs]}
                            emptyMessage={t('userLogs.noUnsubscriptionDetails')}
                            showGridlines
                            responsive
                            scrollable
                            scrollDirection="both"
                            scrollHeight="500px"
                            header={
                                <p className={classes.table_header}>
                                    {t('userLogs.unsubscriptionDetails')}
                                </p>
                            }
                        >
                            <Column field="msisdn" header={t('common.msisdn')}
                            />
                            <Column
                                field="unsub_date"
                                header={t('userLogs.unsubscriptionDateTime')}
                                body={(rowData) =>
                                    moment(rowData?.unsub_date).toLocaleString()
                                }
                            />
                            <Column
                                field="pack_type"
                                header={t('userLogs.packType')}
                            />
                            <Column
                                field="price"
                                header={t('common.amount')}
                            />

                            <Column
                                field="mAct"
                                header={t('userLogs.unsubscriptionChannel')}
                            />
                        </DataTable>
                    </div>
                )
            }
        </Layout>
    )
}

export default UserLogs
